import React, { useEffect, useState } from "react";
import { X, Check } from "lucide-react";
import { RECENT_PURCHASES } from "../mock";

// Shuffle once so the order feels organic
const shuffled = [...RECENT_PURCHASES].sort(() => Math.random() - 0.5);

const SoldNotification = () => {
  const [index, setIndex] = useState(0);
  const [phase, setPhase] = useState("hidden"); // hidden | in | out
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    let timers = [];
    const cycle = (i) => {
      setIndex(i % shuffled.length);
      setPhase("in");
      timers.push(setTimeout(() => setPhase("out"), 5500));
      timers.push(setTimeout(() => cycle(i + 1), 6300));
    };
    const start = setTimeout(() => cycle(0), 4000);
    timers.push(start);
    return () => timers.forEach(clearTimeout);
  }, [dismissed]);

  if (dismissed || phase === "hidden") return null;

  const item = shuffled[index];

  return (
    <div className={`fixed bottom-4 left-4 z-[70] w-[310px] max-w-[calc(100vw-2rem)] ${phase === "out" ? "sold-out" : "sold-in"}`}>
      <div className="relative flex items-center gap-3 rounded-2xl border border-[#e0eee5] bg-white p-3 shadow-[0_14px_40px_-12px_rgba(16,72,50,0.4)]">
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="absolute right-2 top-2 text-[#b0bdb4] transition hover:text-[#2D6A4F]"
        >
          <X size={14} />
        </button>
        <div className="h-14 w-14 shrink-0 overflow-hidden rounded-xl bg-[#f3f8f4]">
          <img src={item.image} alt={item.product} className="h-full w-full object-contain p-1" />
        </div>
        <div className="min-w-0 pr-3">
          <p className="truncate text-[13px] leading-tight text-[#34463c]">
            <span className="font-semibold text-[#1B4332]">{item.name}</span> in {item.place}
          </p>
          <p className="truncate text-[13px] font-semibold leading-tight text-[#2D6A4F]">
            purchased {item.product}
          </p>
          <p className="mt-0.5 flex items-center gap-1 text-[11px] text-[#8aa093]">
            <Check size={11} className="text-[#52B788]" /> {item.ago} · Verified
          </p>
        </div>
      </div>
    </div>
  );
};

export default SoldNotification;
